import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '*',
      redirect: '/'
    }, {
      path: '/',
      name: 'PageView',
      component: resolve => require(['@/view/PageView'], resolve),
      children: [
        {
          path: '/',
          redirect: '/home'
        }, {
          path: '/home',
          name: 'home',
          component: resolve => require(['@/view/HomePage'], resolve),
          meta: {
            title: '首页'
          }
        }, {
          path: '/software',
          name: 'software',
          component: resolve => require(['@/view/Software'], resolve),
          meta: {
            title: '软件产品'
          },
          children: [
            {
              path: '/software',
              redirect: '/software/smartTown'
            },
            {
              path: '/software/smartTown',
              name: 'software',
              component: resolve => require(['@/view/Software_smartTown'], resolve),
              meta: {
                title: '产品中心'
              }
            },
            {
              path: '/software/bigData',
              name: 'software',
              component: resolve => require(['@/view/Software_bigData'], resolve),
              meta: {
                title: '软件产品丨大数据管理系统'
              }
            }
          ]
        }, {
          path: '/service',
          name: 'service',
          component: resolve => require(['@/view/Service'], resolve),
          meta: {
            title: '案例中心'
          }
        }, {
          path: '/newsinformation',
          name: 'newsinformation',
          component: resolve => require(['@/view/NewsInformation'], resolve),
          meta: {
            title: '新闻动态'
          }
        }, {
          path: '/companyintroduction',
          name: 'companyintroduction',
          component: resolve => require(['@/view/CompanyIntroduction'], resolve),
          meta: {
            title: '公司介绍'
          }
        }, {
          path: '/jobchance',
          name: 'jobchance',
          component: resolve => require(['@/view/JobChance'], resolve),
          meta: {
            title: '工作机会'
          }
        }, {
          path: '/contactus',
          name: 'contactus',
          component: resolve => require(['@/view/ContactUs'], resolve),
          meta: {
            title: '联系我们'
          }
        },
        {
          path: '/servicedetail',
          name: 'servicedetail',
          component: resolve => require(['@/view/ServiceDetail'], resolve),
          meta: {
            title: '相关服务'
          }
        },
        // 新闻详情
        {
          path: '/NewsDetail/:id', // 动态路由，id 对应新闻的唯一标识
          name: 'NewsDetail1',
          component: resolve => require(['@/components/news/newdetails1'], resolve),
          meta: {
            title: '新闻详情'
          }
        },
        {
          path: '/NewsDetail/:id', // 动态路由，id 对应新闻的唯一标识
          name: 'NewsDetail2',
          component: resolve => require(['@/components/news/newdetails2'], resolve),
          meta: {
            title: '新闻详情'
          }
        },
        {
          path: '/NewsDetail/:id', // 动态路由，id 对应新闻的唯一标识
          name: 'NewsDetail3',
          component: resolve => require(['@/components/news/newdetails3'], resolve),
          meta: {
            title: '新闻详情'
          }
        },
        {
          path: '/NewsDetail/:id', // 动态路由，id 对应新闻的唯一标识
          name: 'NewsDetail4',
          component: resolve => require(['@/components/news/newdetails4'], resolve),
          meta: {
            title: '新闻详情'
          }
        },
        {
          path: '/NewsDetail/:id', // 动态路由，id 对应新闻的唯一标识
          name: 'NewsDetail5',
          component: resolve => require(['@/components/news/newdetails5'], resolve),
          meta: {
            title: '新闻详情'
          }
        },
        {
          path: '/NewsDetail/:id', // 动态路由，id 对应新闻的唯一标识
          name: 'NewsDetail6',
          component: resolve => require(['@/components/news/newdetails6'], resolve),
          meta: {
            title: '新闻详情'
          }
        },
        {
          path: '/NewsDetail/:id', // 动态路由，id 对应新闻的唯一标识
          name: 'NewsDetail7',
          component: resolve => require(['@/components/news/newdetails7'], resolve),
          meta: {
            title: '新闻详情'
          },
        },
        {
          path: '/NewsDetail/:id', // 动态路由，id 对应新闻的唯一标识
          name: 'NewsDetail8',
          component: resolve => require(['@/components/news/newdetails8'], resolve),
          meta: {
            title: '新闻详情'
          },
        },
        {
          path: '/NewsDetail/:id', // 动态路由，id 对应新闻的唯一标识
          name: 'NewsDetail9',
          component: resolve => require(['@/components/news/newdetails9'], resolve),
          meta: {
            title: '新闻详情'
          },
        },
        {
          path: '/NewsDetail/:id', // 动态路由，id 对应新闻的唯一标识
          name: 'NewsDetail10',
          component: resolve => require(['@/components/news/newdetails10'], resolve),
          meta: {
            title: '新闻详情'
          },
        },
        {
          path: '/NewsDetail/:id', // 动态路由，id 对应新闻的唯一标识
          name: 'NewsDetail11',
          component: resolve => require(['@/components/news/newdetails11'], resolve),
          meta: {
            title: '新闻详情'
          },
        },

        // 案例详情
        {
          path: '/Casedate1/:id', // 动态路由，id 对应新闻的唯一标识
          name: 'Casedate1',
          component: resolve => require(['@/components/cases/casedetails1'], resolve),
          meta: {
            title: '案例详情'
          }
        },
        {
          path: '/Casedate/:id', // 动态路由，id 对应新闻的唯一标识
          name: 'Casedate2',
          component: resolve => require(['@/components/cases/casedetails2'], resolve),
          meta: {
            title: '案例详情'
          }
        },
        {
          path: '/Casedate/:id', // 动态路由，id 对应新闻的唯一标识
          name: 'Casedate3',
          component: resolve => require(['@/components/cases/casedetails3'], resolve),
          meta: {
            title: '案例详情'
          }
        },
        {
          path: '/Casedate/:id', // 动态路由，id 对应新闻的唯一标识
          name: 'Casedate4',
          component: resolve => require(['@/components/cases/casedetails4'], resolve),
          meta: {
            title: '案例详情'
          }
        },
        {
          path: '/Casedate/:id', // 动态路由，id 对应新闻的唯一标识
          name: 'Casedate5',
          component: resolve => require(['@/components/cases/casedetails5'], resolve),
          meta: {
            title: '案例详情'
          }
        },
        {
          path: '/Casedate/:id', // 动态路由，id 对应新闻的唯一标识
          name: 'Casedate6',
          component: resolve => require(['@/components/cases/casedetails6'], resolve),
          meta: {
            title: '案例详情'
          }
        },
        {
          path: '/Casedate/:id', // 动态路由，id 对应新闻的唯一标识
          name: 'Casedate7',
          component: resolve => require(['@/components/cases/casedetails7'], resolve),
          meta: {
            title: '案例详情'
          },
        },
        // -----
        // 产品详情
        {
          path: '/Softsdate/:id', // 动态路由，id 对应新闻的唯一标识
          name: 'Softsdate01',
          component: resolve => require(['@/components/softs/productdetailes01'], resolve),
          meta: {
            title: '产品详情'
          }
        },
        {
          path: '/Softsdate/:id', // 动态路由，id 对应新闻的唯一标识
          name: 'Softsdate03',
          component: resolve => require(['@/components/softs/productdetailes03'], resolve),
          meta: {
            title: '产品详情'
          }
        },
        {
          path: '/Softsdate/:id', // 动态路由，id 对应新闻的唯一标识
          name: 'Softsdate07',
          component: resolve => require(['@/components/softs/productdetailes07'], resolve),
          meta: {
            title: '产品详情'
          },
        },
        // -----
        // 产品详情
        {
          path: '/Softsdate/:id', // 动态路由，id 对应新闻的唯一标识
          name: 'Softsdate1',
          component: resolve => require(['@/components/softs/productdetailes1'], resolve),
          meta: {
            title: '产品详情'
          }
        },
        {
          path: '/Softsdate/:id', // 动态路由，id 对应新闻的唯一标识
          name: 'Softsdate2',
          component: resolve => require(['@/components/softs/productdetailes2'], resolve),
          meta: {
            title: '产品详情'
          }
        },
        {
          path: '/Softsdate/:id', // 动态路由，id 对应新闻的唯一标识
          name: 'Softsdate3',
          component: resolve => require(['@/components/softs/productdetailes3'], resolve),
          meta: {
            title: '产品详情'
          }
        },
        {
          path: '/Softsdate/:id', // 动态路由，id 对应新闻的唯一标识
          name: 'Softsdate4',
          component: resolve => require(['@/components/softs/productdetailes4'], resolve),
          meta: {
            title: '产品详情'
          }
        },
        {
          path: '/Softsdate/:id', // 动态路由，id 对应新闻的唯一标识
          name: 'Softsdate5',
          component: resolve => require(['@/components/softs/productdetailes5'], resolve),
          meta: {
            title: '产品详情'
          }
        },
        {
          path: '/Softsdate/:id', // 动态路由，id 对应新闻的唯一标识
          name: 'Softsdate6',
          component: resolve => require(['@/components/softs/productdetailes6'], resolve),
          meta: {
            title: '产品详情'
          }
        },
        {
          path: '/Softsdate/:id', // 动态路由，id 对应新闻的唯一标识
          name: 'Softsdate7',
          component: resolve => require(['@/components/softs/productdetailes7'], resolve),
          meta: {
            title: '产品详情'
          },
        },
        {
          path: '/Softsdate/:id', // 动态路由，id 对应新闻的唯一标识
          name: 'Softsdate8',
          component: resolve => require(['@/components/softs/productdetailes8'], resolve),
          meta: {
            title: '产品详情'
          },
        },
        {
          path: '/Softsdate/:id', // 动态路由，id 对应新闻的唯一标识
          name: 'Softsdate9',
          component: resolve => require(['@/components/softs/productdetailes9'], resolve),
          meta: {
            title: '产品详情'
          },
        },
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js